import getConfig from "next/config";
import { FAVICON, FAVICON_LOCALHOST, FAVICON_DEVELOPMENT } from "const/images";

enum envTypes {
    LOCALHOST = `localhost`,
    DEVELOPMENT = `development`,
    PRODUCTION = `production`
}

export const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();

export const { environmentType, AWS_ACCOUNT } = publicRuntimeConfig;

export const isDevEnvironment = environmentType === envTypes.DEVELOPMENT;
export const isProdEnvironment = environmentType === envTypes.PRODUCTION;
export const { MASTER_ORGANIZATION_ID, SENTRY_REPORT_URI } =
    serverRuntimeConfig;
export const apiDomain =
    AWS_ACCOUNT === `production` ? `grabyo.com` : `grbydv.com`;

/**
 * @summary - Get the favicon URL for the given or current environment
 *
 * @param [host] - The host of the request referer e.g. studio.grabyo.com
 *
 * @returns
 */
export const getFavicon = (host = ``): string => {
    if (host.includes(envTypes.LOCALHOST)) {
        return FAVICON_LOCALHOST;
    }

    if (host.includes(`grbydv.com`)) {
        return FAVICON_DEVELOPMENT;
    }

    return FAVICON;
};
